import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="logo-container">
          <img src="/enculture-logo.png" alt="Enculture Build Labs" className="logo" />
          <h1 className="logo-text">
            <span className="logo-enculture">Enculture</span>
            <span className="logo-build-labs">Build Labs</span>
          </h1>
        </div>
      </div>
    </header>
  );
};

export default Header;
